import React from 'react';

import { useGetDepartment } from '@vlabs/api/artemy/client';
import type { DepartmentId } from '@vlabs/api/artemy/model';

interface OwnerDepartmentCellProps {
  ownerDepartmentId: DepartmentId;
}

function OwnerDepartmentCell({
  ownerDepartmentId,
}: OwnerDepartmentCellProps): React.JSX.Element {
  const { data: department } = useGetDepartment(ownerDepartmentId);

  return <React.Fragment>{department?.name ?? ownerDepartmentId}</React.Fragment>;
}

export { OwnerDepartmentCell };
